const Roles = {
  CLIENT: 'client',
  COACH: 'coach'
};

export default Roles;